module.exports = __webpack_public_path__ + "img/download-icon-white.f9e3cc4c.svg";